import { render } from "./sce.vue?vue&type=template&id=c04f5cd6"
import script from "./sce.vue?vue&type=script&lang=js"
export * from "./sce.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__